import axios, {AxiosRequestConfig} from "axios";
import {config} from "../domains/config";



export function getTimeString(date:Date): string {
    return `${date.getFullYear()}-${date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)}-${date.getDate() >= 10 ? date.getDate() : "0" + date.getDay()}`
}

export function request(config: AxiosRequestConfig): Promise<any> {
    return new Promise((resolve, reject)=> {
        axios(config).then((res) => {
            resolve(res)
        }).catch(err => {
            if (err.response.status === 403 ) {
                window.location.href ="/web/login"
            }
            reject(err)
        })
    })
}

// export function loadSiteConfig() {
//     request({
//         url: "/web/site-config.json",
//         method: "GET",
//     }).then((res) => {
//         siteConfig.basePath = res.data.basePath
//     })
// }
//
// export const siteConfig: config = {
//     basePath: "/"
// }
